const HttpWithSSL = "https:";

export const isWithSSL = window.location.protocol === HttpWithSSL;
